export const PRIMARY = 'rgb(247, 94, 76)';
export const PRIMARY_DARK = 'rgb(220, 80, 60)';

export const SECONDARY = '#1c679d';
export const SECONDARY_LIGHT = '#4a8abf';
export const SECONDARY_DARK = '#14496e';

export const SUCCESS = '#4CAF50';
export const SUCCESS_DARK = '#43A047';

export const INFO = '#1976d2';
export const INFO_DARK = '#1565c0';
export const INFO_DARKER = '#0d47a1';

export const WARNING = '#ff9800';

export const ERROR = '#d32f2f';
export const ERROR_LIGHT = '#ff1744';

export const WHITE = '#ffffff';


export const MAP_DRAW            = '#3b82f6';
export const MAP_DRAW_ACTIVE     = '#2563eb';
export const MAP_DEFAULT_STYLE   = '#3388ff';
export const MAP_SNAP            = '#22c55e';
export const MAP_ERROR_HIGHLIGHT    = '#ff0000';
export const MAP_SEARCH_HIGHLIGHT   = '#000000';
export const MAP_WYPIS_HIGHLIGHT    = '#8B5CF6';
export const MAP_FALLBACK        = '#cccccc';
export const MAP_BUILDING_3D     = '#aaa';
export const MAP_BUILDING_SELECTED = '#FF8C00';

export const OVERLAY_BG = 'rgba(0,0,0,0.5)';

export const CHART_OVERVIEW_COLORS = ['#3b82f6', '#10b981', '#8b5cf6', '#f97316', '#ec4899'] as const;
export const CHART_AUDIT_COLORS    = ['#10b981', '#3b82f6', '#ef4444', '#f59e0b'] as const;
export const CHART_TOOLTIP_STYLE   = { borderRadius: '8px' } as const;

export const LAYER_ICON_RASTER  = 'rgb(168, 85, 247)';
export const LAYER_ICON_POINT   = 'rgb(239, 68, 68)';
export const LAYER_ICON_LINE    = 'rgb(34, 197, 94)';
export const LAYER_ICON_POLYGON = 'rgb(59, 130, 246)';
export const LAYER_ICON_FOLDER  = 'rgb(245, 158, 11)';

export const withAlpha = (rgb: string, alpha: number): string => {
  const match = rgb.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (match) return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${alpha})`;
  const hex = rgb.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
